import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import consumer from '../../Common/cable'
import _ from 'lodash'
import { Logs } from '../../Common/Common'

export default function LogsPanel ({ logs, date, slotId, boxId }) {
  const [newLog, setNewLog] = useState(null)
  const [displayLogs, setDisplayLogs] = useState([])

  useEffect(() => {
    if ((dayjs(newLog?.created_at).isSame(dayjs(date), 'day')) &&
      ((newLog?.slot_id === slotId) || (newLog?.box_id === boxId))) {
      setDisplayLogs([{ ...newLog, display: newLog?.message }, ...displayLogs])
    }
  }, [newLog])

  useEffect(() => {
    const formatedLogs = logs?.map((log) => ({ ...log, display: log?.message })) || []
    setDisplayLogs(formatedLogs)
  }, [logs])

  useEffect(() => {
    consumer.subscriptions.create({ channel: 'LogsChannel' }, {
      connected: () => { console.log('connected LogsChannel') },
      disconnected: () => { },
      received: (data) => { setNewLog(data) }
    })
  }, [])

  return (
    <Logs
      entries={_.orderBy(displayLogs, ['created_at'], ['desc'])}
      title={dayjs(date).format('dddd DD MMMM YYYY')}
    />
  )
}
